import React from "react";
import IconNatemat from "../../assets/img/natemat/dociekliwosc_dziennikarska_natemat.svg"

import { AttachmentElement } from "../../components/Article/Parts/Slate/types"
import AttachmentContentBase from "./AttachmentBase";


type AttachmentProps = {
    element: AttachmentElement;
};

const AttachmentContent: React.FC<AttachmentProps> = ({
    element,
}) => {

    return (
        <AttachmentContentBase element={element} icon={IconNatemat} />
    );
};

export default AttachmentContent
